// extracted by mini-css-extract-plugin
export default {"root":"auth-layout_root__2a5nr"};